import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburgerMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M35.143 10.578H4.857A.857.857 0 0 1 4 9.72V7.437c0-.473.384-.856.857-.856h30.286c.473 0 .857.383.857.856v2.284a.857.857 0 0 1-.857.857Zm0 11.42H4.857A.857.857 0 0 1 4 21.143v-2.284c0-.473.384-.857.857-.857h30.286c.473 0 .857.384.857.857v2.284a.857.857 0 0 1-.857.857Zm0 11.421H4.857A.857.857 0 0 1 4 32.563v-2.284c0-.473.384-.857.857-.857h30.286c.473 0 .857.384.857.857v2.284a.857.857 0 0 1-.857.856Z" })
});
export default SvgHamburgerMenu;
